import React, { useEffect, useState, useMemo, useRef } from "react";
// @material-ui/core components
import {
  Box,
  InputAdornment,
  Checkbox,
  Dialog,
  Fab,
  FormControlLabel,
  IconButton,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
  TextField,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import People from "@material-ui/icons/People";
import DateUtils from "@date-io/moment";

// core components
import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";
import CustomInput from "../../components/CustomInput/CustomInput.js";
import Button from "../../components/CustomButtons/Button.js";
import Card from "../../components/Card/Card.js";
import CardHeader from "../../components/Card/CardHeader.js";
import CardBody from "../../components/Card/CardBody.js";
import CardFooter from "../../components/Card/CardFooter.js";
import _ from "lodash";
import axios from "axios";
import AddIcon from "@material-ui/icons/Add";
import { Autocomplete } from "@material-ui/lab";
import Check from "@material-ui/icons/Check";
import styles from "../../../src/assets/jss/material-dashboard-react/checkboxAdnRadioStyle.js";
import DeleteIcon from "@material-ui/icons/Delete";
import {
  CreateProductMasterAPI,
  CreatePurchaseAPI,
  CreateReadyMasterAPI,
  GetAllAccountsAPI,
  GetAllAccountsWithLightweightAPI,
  GetAllProductMastersAPI,
  GetAllPurchasesAPI,
  GetAllReadyMastersAPI,
  GetBulkReadyMasterRangeAPI,
  GetReadyMasterRangeProducts,
  UpdateProductMasterAPI,
  UpdateReadyMasterAPI,
  GetAllLedgersAPI,
} from "../../config/api";
import { useSelector } from "react-redux";

import { createFilterOptions } from "@material-ui/lab/Autocomplete";
import { toast } from "react-toastify";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from "moment";
import { calculateRunningBalance } from "../../utils/index.js";

const filterOptions = createFilterOptions({
  matchFrom: "any",
  limit: 500,
});

let s = _.merge(styles, {
  formControl: {
    paddingBottom: "10px",
    margin: "27px 0 0 0",
    position: "relative",
    verticalAlign: "unset",
  },
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
});

const useStyles = makeStyles(theme => ({
  ...s,
  // Add new styles
  inputLabel: {
    fontSize: '1rem',
    fontWeight: 500,
    color: '#495057',
  },
  input: {
    '& .MuiInputBase-input': {
      fontSize: '1.1rem',
      fontWeight: 400,
      color: '#2c3e50',
    },
    '& .MuiInputBase-input::placeholder': {
      fontSize: '1.1rem',
      color: '#95a5a6',
      opacity: 1,
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#bdc3c7',
        borderWidth: 2,
      },
      '&:hover fieldset': {
        borderColor: '#7f8c8d',
      },
    },
  },
  autocomplete: {
    '& .MuiAutocomplete-input': {
      fontSize: '1.1rem',
      fontWeight: 400,
    },
  },
  tableHeader: {
    '& .MuiTableCell-head': {
      fontSize: '1.1rem',
      fontWeight: 600,
      backgroundColor: '#f8f9fa',
      color: '#2c3e50',
    },
  },
  tableCell: {
    fontSize: '1rem',
    color: '#2c3e50',
  }
}));

const readyMasterRangeProductColumn = [
  { id: "index", label: "Sr No." },
  { id: "productCode", label: "Product Code" },

  { id: "sph", label: "Sph" },
  { id: "cyl", label: "Cyl" },
  { id: "axis", label: "Axis" },
  { id: "addition", label: "Addition" },
  { id: "threshold", label: "Threshold" },
  { id: "quantity", label: "Existing Quantity" },
  { id: "newQuantity", label: "New Quantity" },
  { id: "totalQuantity", label: "Total Quantity" },
];

const productColumns = [
  { id: "productCode", label: "Product Code" },
  { id: "productName", label: "Product Name" },
  { id: "addedQuantity", label: "Quantity" },
  { id: "rate", label: "Purchase Rate" },
  { id: "total", label: "Total" },
  { id: "action", label: "Action" },
];
const productOptions = [
  "Product 1",
  "Product 2",
  "Product 3",
  "Product 4",
  "Product 5",
];

const gstPer = [
  { label: "12% GST", value: 12 },
  { label: "18% GST", value: 18 },
];

const sides = ["B", "L", "R"];

export default function PurchaseAdd(props) {
  const classes = useStyles();
  const theme = useTheme();
  const userInfo = useSelector((state) => state.userReducer.userInfo);
  const authToken = useSelector((state) => state.userReducer.authToken);

  const { open, close, type, fetchData } = props;
  const fullScreen = useMediaQuery(theme.breakpoints.down("xs"));
  // const readyMasters = useSelector((state) => state.userReducer.readyMasters);

  // console.log(ready)

  const [products, setProducts] = useState([]);
  const [challan, setChallan] = useState(null);
  const [bill, setBill] = useState(null);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [product, setProduct] = useState("");
  const [party, setParty] = useState(null);
  const [calculatedChallanBalance, setCalculatedChallanBalance] = useState(0);
  const [calculatedBillBalance, setCalculatedBillBalance] = useState(0);
  const [isCalculatingBalances, setIsCalculatingBalances] = useState(false);

  const [color, setColor] = useState("");
  const [productName, setProductName] = useState("");
  const [productCode, setProductCode] = useState("");
  const [rate, setRate] = useState("");
  const [saleRate, setSaleRate] = useState("");
  const [index, setIndex] = useState("");
  const [side, setSide] = useState("");
  const [types, setTypes] = useState("");
  const [threshold, setThreshold] = useState("");
  const [sph, setSph] = useState("0");
  const [cyl, setCyl] = useState("0");
  const [axis, setAxis] = useState("0");
  const [addition, setAddition] = useState("0");
  const [hsnCode, setHsnCode] = useState("");
  const [taxPercent, setTaxPercent] = useState("");
  const [loading, setLoading] = useState(false);

  const [existingQuantity, setExistingQuantity] = useState("");
  const [newQuantity, setNewQuantity] = useState("");
  const [totalQuantity, setTotalQuantity] = useState("");
  const [total, setTotal] = useState("");
  const [netAmount, setNetAmount] = useState("");
  const [totalBillAmount, setTotalBillAmount] = useState("");
  const [selectedGSTPer, setSelectedGSTPer] = useState("");
  const [purchaseType, setPurchaseType] = useState("Challan");
  const [readyMasterRange, setReadyMasterRange] = useState([]);
  const [selectedReadyMasterRange, setSelectedReadyMasterRange] =
    useState(null);
  const [readyMasterRangeProducts, setReadyMasterRangeProduct] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [packagingAmount, setPackagingAmount] = useState("");
  const [purchaseDate, setPurchaseDate] = useState(null);
  const [readyMasterRangeLoading, setReadyMasterRangeLoading] = useState(false);
  const [readyMasterRangeSearchInput, setReadyMasterRangeSearchInput] = useState("");

  // Product list state
  const [productListTotal, setProductListTotal] = useState(0);
  // Store all product updates (threshold/newQuantity) separately to persist across searches
  const [productUpdates, setProductUpdates] = useState({}); // Format: { productId: { newQuantity, threshold, rate, quantity } }

  const [saveButtonStatus, setSaveButtonStatus] = useState(false);

  useEffect(() => {
    if (open) {
      _getAccounts();
      // Load initial data with limit to improve performance
      _getBulkReadyMasterRangeAPI("", 100, 0);
    }

    // Cleanup debounced function on unmount
    return () => {
      if (debouncedReadyMasterRangeSearch) {
        debouncedReadyMasterRangeSearch.cancel();
      }
    };
  }, [open]);

  useEffect(() => {
    if (selectedReadyMasterRange != null) {
      setLoading(true);
      setSearchTerm(""); // Clear search when new product is selected
      setProductUpdates({}); // Clear updates when new product range is selected
      hasInitialLoad.current = false; // Reset for new product selection
      _getBulkReadyMasterRangeProductsAPI("", 50, 0); // Fetch 50 products initially
    } else {
      setReadyMasterRangeProduct([]);
      setLoading(false);
      setProductListTotal(0);
      setSearchTerm("");
      setProductUpdates({});
      hasInitialLoad.current = false;
    }
  }, [selectedReadyMasterRange]);

  // Track initial load for search debouncing
  const hasInitialLoad = useRef(false);
  useEffect(() => {
    if (selectedReadyMasterRange != null) {
      // Skip search on initial mount (already loaded 50 products)
      if (!hasInitialLoad.current) {
        hasInitialLoad.current = true;
        return;
      }

      const timeoutId = setTimeout(() => {
        if (searchTerm.trim() === "") {
          // Clear search - load initial 50 products
          _getBulkReadyMasterRangeProductsAPI("", 50, 0);
        } else {
          // Server-side search
          _getBulkReadyMasterRangeProductsAPI(searchTerm, 50, 0);
        }
      }, 300);

      return () => clearTimeout(timeoutId);
    }
  }, [searchTerm]);

  // Calculate net amount from all product updates (including ones not currently visible)
  useEffect(() => {
    let netAmountTemp = 0;

    // Calculate from all stored updates
    Object.values(productUpdates).forEach((update) => {
      if (update.newQuantity > 0 && update.rate) {
        netAmountTemp += Number(update.newQuantity) * Number(update.rate);
      }
    });

    // Also include current page products that haven't been saved to productUpdates yet
    readyMasterRangeProducts.forEach((product) => {
      const productId = product._id || product.productCode;
      if (!productUpdates[productId] && product.newQuantity > 0) {
        netAmountTemp += Number(product.newQuantity) * Number(product.rate || 0);
      }
    });

    let totalBillAmount = netAmountTemp + Number(packagingAmount || 0);
    setNetAmount(netAmountTemp);
    if (taxPercent && purchaseType === "Bill") {
      totalBillAmount =
        netAmountTemp +
        Number(packagingAmount || 0) +
        netAmountTemp * (Number(taxPercent) / 100);
    }
    setTotalBillAmount(totalBillAmount);
  }, [productUpdates, readyMasterRangeProducts, packagingAmount, taxPercent, purchaseType]);

  useEffect(() => {
    setProducts([]);
    setChallan(null);
    setBill(null);
    setSelectedProducts([]);
    setProduct("");
    setParty(null);
    setColor("");
    setProductName("");
    setProductCode("");
    setRate("");
    setIndex("");
    setSide("");
    setTypes("");
    setThreshold("");
    setSph("0");
    setCyl("0");
    setAxis("0");
    setAddition("0");
    setHsnCode("");
    setTaxPercent("");
    setExistingQuantity("");
    setNewQuantity("");
    setTotalQuantity("");
    setTotal("");
    setNetAmount("");
    setTotalBillAmount("");
    setSelectedGSTPer("");
    setSelectedReadyMasterRange(null);
    setSearchTerm("");
    setPackagingAmount("");
    setPurchaseDate(null);
  }, [purchaseType]);

  const manageDataPunching = (row, event, parameter) => {
    try {
      if (!row || !event || !event.target) {
        console.error("Invalid parameters:", { row, event });
        return;
      }

      const productId = row._id || row.productCode || row.code;
      if (!productId) {
        console.error("Product ID not found:", row);
        return;
      }

      // Update the productUpdates state to persist across searches
      setProductUpdates((prev) => {
        const updated = { ...prev };

        if (!updated[productId]) {
          updated[productId] = {
            rate: row.rate || 0,
            quantity: row.quantity || 0,
            productCode: row.productCode || "",
          };
        }

        if (parameter === "threshold") {
          const value = event.target.value;
          const enteredValue = (value !== "" && value !== null && value !== undefined) ? (parseInt(value) || 0) : 0;
          updated[productId].threshold = enteredValue;
        } else if (parameter === "totalQuantity") {
          // This is for newQuantity input
          const newQty = event.target.value !== "" ? (parseInt(event.target.value) || 0) : 0;
          updated[productId].newQuantity = newQty;
        }

        return updated;
      });

      // Also update the current page's displayed products for immediate UI update
      let copy = _.cloneDeep(readyMasterRangeProducts);
      let rowIndex = _.findIndex(copy, (item) => {
        if (!item) return false;
        const itemId = item._id || item.productCode || item.code;
        return itemId === productId;
      });

      if (rowIndex !== -1 && copy[rowIndex]) {
        if (parameter === "threshold") {
          const value = event.target.value;
          let enteredValue = (value !== "" && value !== null && value !== undefined) ? (parseInt(value) || 0) : 0;
          copy[rowIndex]["threshold"] = enteredValue;
          setReadyMasterRangeProduct(copy);
        } else if (parameter === "totalQuantity") {
          if (event.target.value !== "") {
            let newQty = parseInt(event.target.value) || 0;
            let originalQty = parseInt(copy[rowIndex]["quantity"] || 0);
            copy[rowIndex]["newQuantity"] = newQty;
            copy[rowIndex]["totalQuantity"] = originalQty + newQty;
            setReadyMasterRangeProduct(copy);
          } else {
            let originalQty = parseInt(copy[rowIndex]["quantity"] || 0);
            copy[rowIndex]["newQuantity"] = 0;
            copy[rowIndex]["totalQuantity"] = originalQty;
            setReadyMasterRangeProduct(copy);
          }
        }
      }
    } catch (error) {
      console.error("Error in manageDataPunching:", error, { row, event, parameter });
      toast.error("An error occurred while updating the product. Please try again.", {
        position: "top-center",
        autoClose: 2000,
      });
    }
  };

  //   const manageDataPunching = (row, event, parameter) => {
  //   let copy = _.cloneDeep(readyMasterRangeProducts); // Ensure deep clone to prevent state mutation issues
  //   let rowIndex = _.findIndex(copy, row); // Use the copied array

  //   if (rowIndex !== -1) {
  //     if (event.target.value !== "") {
  //       let enteredValue = parseInt(event.target.value) || 0; // Ensure number parsing

  //       if (parameter === "threshold") {
  //         copy[rowIndex]["threshold"] = enteredValue; // Directly update threshold
  //       } else if (parameter === "newQuantity") {
  //         copy[rowIndex]["newQuantity"] = enteredValue;
  //         copy[rowIndex]["totalQuantity"] =
  //           parseInt(copy[rowIndex]["quantity"]) + enteredValue;
  //       }

  //       setReadyMasterRangeProduct(copy);
  //     } else {
  //       if (parameter === "threshold") {
  //         copy[rowIndex]["threshold"] = 0; // Reset threshold if empty
  //       } else if (parameter === "newQuantity") {
  //         copy[rowIndex]["newQuantity"] = 0;
  //         copy[rowIndex]["totalQuantity"] = parseInt(copy[rowIndex]["quantity"]);
  //       }

  //       setReadyMasterRangeProduct(copy);
  //     }
  //   }
  // };


  // Debounced product search with working pagination
  // To use pagination, call debouncingProducts(value, { skip: N, limit: M })
  const debouncingProducts = _.debounce(
    async (value, options = {}) => {
      try {
        // Allow skip/limit to be passed for pagination, fallback to defaults
        const limit = options.limit !== undefined ? options.limit : 15;
        const skip = options.skip !== undefined ? options.skip : 0;
        let query = `&productCode=${value}&limit=${limit}&skip=${skip}`;
        let res = await axios.get(
          GetAllReadyMastersAPI(userInfo.entity) + query,
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        setProducts(res.data.readyMasters || []);
      } catch (err) {
        toast.error("Failed to search products. Please try again.");
      }
    },
    400
  );

  // async function _getProducts() {
  //   try {
  //     let res = await axios.get(GetAllReadyMastersAPI(userInfo.entity), {
  //       headers: {
  //         Authorization: `Bearer ${authToken}`,
  //       },
  //     });
  //     setProducts(res.data.readyMasters);
  //   } catch (err) {
  //     // console.log(err);
  //   }
  // }

  async function _getAccounts() {
    try {
      // Use lightweight endpoint with partyType filter for better performance
      let res = await axios.get(GetAllAccountsWithLightweightAPI(userInfo.entity, 'purchase'), {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      setAccounts(res.data.accounts || []);
    } catch (err) {
      toast.error("Failed to load accounts. Please try again.", {
        position: "top-center",
        autoClose: 2000,
      });
      setAccounts([]);
    }
  }

  async function _onSave() {
    if (saveButtonStatus) return;
    try {
      if (type === "Single Product" && _.isEmpty(selectedProducts)) {
        return alert("Please add products");
      }
      let fData = null;
      if (type === "Range Product") {
        // Fetch all products to merge with all stored updates before saving
        try {
          const allProductsRes = await axios.get(
            GetReadyMasterRangeProducts(
              userInfo.entity,
              selectedReadyMasterRange.startSph || "",
              selectedReadyMasterRange.endSph || "",
              selectedReadyMasterRange.startCyl || "",
              selectedReadyMasterRange.endCyl || "",
              selectedReadyMasterRange.startAddition || "",
              selectedReadyMasterRange.endAddition || "",
              selectedReadyMasterRange.axis || "",
              selectedReadyMasterRange.color || "",
              selectedReadyMasterRange.productName || "",
              10000, // High limit to get all products
              0,
              "" // No search
            ),
            {
              headers: {
                Authorization: `Bearer ${authToken}`,
              },
            }
          );

          // Merge all products with their stored updates
          const allProductsWithUpdates = (allProductsRes.data.readyMasterRangeProducts || []).map((product) => {
            const productId = product._id || product.productCode || product.code;
            const update = productUpdates[productId] || {};

            const newQuantity = update.newQuantity !== undefined ? update.newQuantity : (product.newQuantity || 0);
            const threshold = update.threshold !== undefined ? update.threshold : (product.threshold || 0);
            const totalQuantity = (product.quantity || 0) + newQuantity;

            return {
              ...product,
              newQuantity,
              addedQuantity: newQuantity, // Add addedQuantity for table display
              threshold,
              quantity: totalQuantity,
              total: Number(totalQuantity) * Number(product.rate || 0),
            };
          });

          fData = allProductsWithUpdates.filter((tc) => (tc.newQuantity || 0) > 0);
        } catch (err) {
          console.error("Error fetching all products for save:", err);
          // Fallback to current page products if fetch fails
          await Promise.all(
            readyMasterRangeProducts.map((i) => {
              const productId = i._id || i.productCode || i.code;
              const update = productUpdates[productId] || {};
              i.newQuantity = update.newQuantity !== undefined ? update.newQuantity : (i.newQuantity || 0);
              i.addedQuantity = i.newQuantity; // Add addedQuantity for table display
              i.quantity = (i.quantity || 0) + i.newQuantity;
              i.total = Number(i.quantity) * Number(i.rate);
            })
          );
          fData = readyMasterRangeProducts.filter((tc) => (tc.newQuantity || 0) > 0);
        }
      }

      if (party === "") {
        toast.error("Please Select a party");
        return;
      }

      let purchase = {
        purchaseType,
        type,
        challanNo: challan,
        billNo: bill,
        products: type === "Single Product" ? selectedProducts : fData,
        readyMasterRange:
          type === "Range Product" ? selectedReadyMasterRange : null,
        party,
        gst: bill ? taxPercent : 0,
        gstAmount: bill ? Number(totalBillAmount) - Number(netAmount) : 0,
        netAmount,
        totalAmount: totalBillAmount,
        entity: userInfo.entity,
        hsnCode: hsnCode,
        taxPercent: taxPercent,
        purchaseDate: purchaseDate ? moment.utc(purchaseDate) : moment.utc(),
        packagingAmount,
      };

      setSaveButtonStatus(true);

      await axios.post(CreatePurchaseAPI(), purchase, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      toast.success("Purchase created successfully", {
        position: "top-center",
        autoClose: 2000,
      });

      // if (!_.isEmpty(selectedProducts)) {
      //   await Promise.all(
      //     selectedProducts.map(async (i) => {
      //       console.log(i);
      //       if (!_.isEmpty(i._id)) {
      //         res = await axios.patch(UpdateReadyMasterAPI(i._id), i, {
      //           headers: {
      //             Authorization: `Bearer ${authToken}`,
      //           },
      //         });
      //       }
      //     })
      //   );
      // }

      // if (!_.isEmpty(fData)) {
      //   await Promise.all(
      //     fData.map(async (i) => {
      //       if (!_.isEmpty(i._id)) {
      //         res = await axios.patch(UpdateReadyMasterAPI(i._id), i, {
      //           headers: {
      //             Authorization: `Bearer ${authToken}`,
      //           },
      //         });
      //       }
      //     })
      //   );
      // }
      close();
      setProductUpdates({}); // Clear all updates after successful save
      fetchData();
    } catch (e) {
      toast.error("Failed to create purchase. Please try again.", {
        position: "top-center",
        autoClose: 2000,
      });
    } finally {
      setSaveButtonStatus(false);
    }
    setSelectedProducts([]);
  }

  // Optimized function to fetch ReadyMasterRange with pagination and search
  async function _getBulkReadyMasterRangeAPI(productName = "", limit = 100, skip = 0) {
    try {
      setReadyMasterRangeLoading(true);
      let queryParams = `&limit=${limit}&skip=${skip}`;
      const isSearch = productName && productName.length > 0;
      if (isSearch) {
        queryParams += `&productName=${encodeURIComponent(productName)}`;
      }

      const url = GetBulkReadyMasterRangeAPI(userInfo.entity) + queryParams;

      let res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      setReadyMasterRange(res.data.readyMasterRange || []);
    } catch (err) {
      toast.error("Failed to load products. Please try again.");
      setReadyMasterRange([]);
    } finally {
      setReadyMasterRangeLoading(false);
    }
  }

  // Debounced search function for ReadyMasterRange Autocomplete
  // Using useMemo to create debounced function - inlined to avoid closure issues
  const debouncedReadyMasterRangeSearch = useMemo(
    () => _.debounce((searchValue) => {
      setReadyMasterRangeLoading(true);
      let queryParams = `&limit=20000000&skip=0`;
      if (searchValue && searchValue.length > 0) {
        queryParams += `&productName=${encodeURIComponent(searchValue)}`;
      }

      const url = GetBulkReadyMasterRangeAPI(userInfo.entity) + queryParams;

      axios.get(url, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
        .then((res) => {
          setReadyMasterRange(res.data.readyMasterRange || []);
        })
        .catch((err) => {
          toast.error("Failed to search products. Please try again.");
          setReadyMasterRange([]);
        })
        .finally(() => {
          setReadyMasterRangeLoading(false);
        });
    }, 400),
    [userInfo.entity, authToken] // Recreate when entity or authToken changes
  );

  async function _getBulkReadyMasterRangeProductsAPI(searchValue = "", limit = 50, skip = 0) {
    if (!selectedReadyMasterRange) {
      setReadyMasterRangeProduct([]);
      setLoading(false);
      setProductListTotal(0);
      return;
    }

    try {
      setLoading(true);
      let res = await axios.get(
        GetReadyMasterRangeProducts(
          userInfo.entity,
          selectedReadyMasterRange.startSph || "",
          selectedReadyMasterRange.endSph || "",
          selectedReadyMasterRange.startCyl || "",
          selectedReadyMasterRange.endCyl || "",
          selectedReadyMasterRange.startAddition || "",
          selectedReadyMasterRange.endAddition || "",
          selectedReadyMasterRange.axis || "",
          selectedReadyMasterRange.color || "",
          selectedReadyMasterRange.productName || "",
          limit,
          skip,
          searchValue
        ),
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      // Initialize products with newQuantity and threshold, merge with stored updates
      const products = (res.data.readyMasterRangeProducts || []).map((product) => {
        const productId = product._id || product.productCode || product.code;
        const storedUpdate = productUpdates[productId] || {};

        // Ensure newQuantity is always a number, never null or undefined
        const newQtyValue = storedUpdate.newQuantity !== undefined
          ? storedUpdate.newQuantity
          : (product.newQuantity !== null && product.newQuantity !== undefined ? product.newQuantity : 0);
        const newQuantity = Number(newQtyValue) || 0;
        // Ensure threshold is always a number, never null or undefined
        const thresholdValue = storedUpdate.threshold !== undefined
          ? storedUpdate.threshold
          : (product.threshold !== null && product.threshold !== undefined ? product.threshold : 0);
        const threshold = Number(thresholdValue) || 0;
        const totalQuantity = (product.quantity || 0) + newQuantity;

        return {
          ...product,
          newQuantity,
          threshold,
          totalQuantity,
        };
      });

      setReadyMasterRangeProduct(products);
      setProductListTotal(res.data.total || 0);
      hasInitialLoad.current = true; // Mark initial load complete
    } catch (err) {
      console.error("Error fetching products:", err);
      toast.error("Failed to load product range. Please try again.", {
        position: "top-center",
        autoClose: 2000,
      });
      setReadyMasterRangeProduct([]);
      setProductListTotal(0);
    } finally {
      setLoading(false);
    }
  }

  // Function to calculate running balances for purchase activity
  // This uses the global calculateRunningBalance function from utils/index.js
  // with activityType set to "purchase" to filter only purchase transactions
  // This ensures we only see running balances related to purchase activities
  async function _calculateRunningBalances(selectedParty) {
    setIsCalculatingBalances(true);
    try {
      // Calculate Challan running balance for purchase activity
      const challanBalance = await calculateRunningBalance(
        selectedParty,
        "Challan",
        userInfo,
        authToken,
        GetAllLedgersAPI,
        null, // transactionType (null for all)
        "purchase" // activityType - specifically for purchase
      );
      setCalculatedChallanBalance(challanBalance);

      // Calculate Bill running balance for purchase activity
      const billBalance = await calculateRunningBalance(
        selectedParty,
        "Bill",
        userInfo,
        authToken,
        GetAllLedgersAPI,
        null, // transactionType (null for all)
        "purchase" // activityType - specifically for purchase
      );
      setCalculatedBillBalance(billBalance);
    } catch (error) {
      console.error('Error calculating running balances:', error);
      // Fallback to existing values
      setCalculatedChallanBalance(selectedParty?.runningChallanBalance || 0);
      setCalculatedBillBalance(selectedParty?.runningBillBalance || 0);
    } finally {
      setIsCalculatingBalances(false);
    }
  }

  // Data to display (no client-side pagination needed - server handles it)
  const data = readyMasterRangeProducts;

  // Memoize readyMasterRange options for Autocomplete
  const memoizedReadyMasterRangeOptions = useMemo(() => {
    return readyMasterRange;
  }, [readyMasterRange]);

  return (
    <Dialog
      fullWidth
      fullScreen
      open={open}
      onClose={close}
      aria-labelledby="responsive-dialog-title"
    >
      <GridContainer>
        <GridItem xs={12} sm={12}>
          <Card>
            <CardHeader color="primary">
              <Box
                display={"flex"}
                alignItems={"center"}
                justifyContent={"space-between"}
              >
                <h4 className={classes.cardTitleWhite}>Add Purchase</h4>
                <h4 className={classes.cardTitleWhite}>O.B Ch : {party?.openingChallanBalance}</h4>
                <h4 className={classes.cardTitleWhite}>O.B Bill : {party?.openingBillBalance}</h4>

                {party?.showRunningBalance ? (
                  <>
                    <h4 className={classes.cardTitleWhite}>R.B Ch : {isCalculatingBalances ? "Calculating..." : _.round(calculatedChallanBalance, 2)}</h4>
                    <h4 className={classes.cardTitleWhite}>R.B Bill : {isCalculatingBalances ? "Calculating..." : _.round(calculatedBillBalance, 2)}</h4>
                  </>
                ) : null}
                {Object.keys(productUpdates).length > 0 && (
                  <Box
                    style={{
                      backgroundColor: "#ff9800",
                      color: "white",
                      padding: "8px 16px",
                      borderRadius: "4px",
                      fontSize: "14px",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <span>⚠️</span>
                    <span>
                      {Object.values(productUpdates).filter((u) => (u.newQuantity || 0) > 0 || (u.threshold || 0) > 0).length} product(s) with unsaved changes
                    </span>
                  </Box>
                )}
                <Button disabled={saveButtonStatus} color={"transparent"} onClick={() => _onSave()}>
                  {saveButtonStatus ? "Saving…" : "Save"}
                </Button>
              </Box>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={3} md={3} sm={3}>
                  <Autocomplete
                    id="purchaseType"
                    className={classes.formControl}
                    options={["Challan", "Bill"]}
                    value={purchaseType}
                    onChange={(event, value) => {
                      setPurchaseType(value);
                    }}
                    getOptionLabel={(option) => option}
                    renderInput={(params) => (
                      <TextField {...params} label="Select Purchase Type" />
                    )}
                  />
                </GridItem>
                <GridItem xs={3} sm={3} md={3}>
                  <MuiPickersUtilsProvider utils={DateUtils}>
                    <DatePicker
                      label="Purchase Date"
                      fullWidth
                      value={purchaseDate}
                      onChange={(date) => setPurchaseDate(date)}
                      animateYearScrolling
                    // style={{marginTop:5}}
                    />
                  </MuiPickersUtilsProvider>
                </GridItem>
                <GridItem xs={3} sm={3} md={3}>
                  {purchaseType === "Challan" ? (
                    <CustomInput
                      labelText="Challan No."
                      id="challan"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: challan,
                        onChange: (event) => setChallan(event.target.value),
                      }}
                    />
                  ) : (
                    <CustomInput
                      labelText="Bill No"
                      id="bill"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: bill,
                        onChange: (event) => setBill(event.target.value),
                      }}
                    />
                  )}
                </GridItem>
                <GridItem xs={3} md={3} sm={3}>
                  <Autocomplete
                    id="product"
                    className={classes.formControl}
                    options={accounts}
                    value={party}
                    onChange={(event, value) => {
                      setParty(value);
                      if (value) {
                        _calculateRunningBalances(value);
                      } else {
                        setCalculatedChallanBalance(0);
                        setCalculatedBillBalance(0);
                      }
                    }}
                    getOptionLabel={(option) => option.name}
                    renderInput={(params) => (
                      <TextField {...params} label="Select Party" />
                    )}
                  />
                </GridItem>
                <GridItem xs={4} sm={4} md={4}>
                  <CustomInput
                    labelText="Gross Amount"
                    id="netAmount"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      disabled: true,
                      value: netAmount,
                      // onChange: (event) => {
                      //   setNetAmount(event.target.value);
                      //   let totalBillAmount = Number(event.target.value) + Number(packagingAmount)
                      //   if (taxPercent && purchaseType === "Bill") {
                      //     totalBillAmount =
                      //       Number(event.target.value) +
                      //       Number(event.target.value)
                      //   }
                      //   setTotalBillAmount(totalBillAmount);
                      // },
                    }}
                  />
                </GridItem>
                <GridItem xs={4} sm={4} md={4}>
                  <CustomInput
                    labelText="Packaging Amount"
                    id="packagingAmount"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: packagingAmount,
                      onChange: (event) => {
                        setPackagingAmount(event.target.value);
                        let totalBillAmount = 0;
                        if (purchaseType === "Bill") {
                          totalBillAmount =
                            Number(event.target.value) +
                            Number(netAmount) +
                            (Number(event.target.value) + Number(netAmount)) *
                            (Number(taxPercent) / 100);
                        }
                        if (purchaseType === "Challan") {
                          totalBillAmount =
                            Number(event.target.value) + Number(netAmount);
                        }
                        setTotalBillAmount(totalBillAmount);
                      },
                    }}
                  />
                </GridItem>

                {/* {purchaseType === "Bill" ? (
                  <GridItem xs={4} sm={4} md={4}>
                    <Autocomplete
                      id="gst"
                      className={classes.formControl}
                      options={gstPer}
                      value={selectedGSTPer}
                      onChange={(event, value) => {
                        setSelectedGSTPer(value);
                        let totalBillAmount = Number(netAmount);
                        if (value) {
                          totalBillAmount =
                            Number(netAmount) +
                            Number(netAmount) * (Number(value.value) / 100);
                        }
                        setNetAmount(netAmount);
                        setTotalBillAmount(totalBillAmount);
                      }}
                      getOptionLabel={(option) => option.label}
                      renderInput={(params) => (
                        <TextField {...params} label="Select GST%" />
                      )}
                    />
                  </GridItem>
                ) : null} */}
                <GridItem xs={4} sm={4} md={4}>
                  <CustomInput
                    labelText={
                      purchaseType === "Bill"
                        ? "Total Bill Amount (gross + packaging + tax)"
                        : "Total Bill Amount"
                    }
                    id="totalBillAmount"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: purchaseType === "Bill" ? `${totalBillAmount} ( ${netAmount} + ${(Number(packagingAmount) + Number(packagingAmount * (taxPercent / 100)))} + ${Number(netAmount * (taxPercent / 100))} )` : totalBillAmount,
                      disabled: true,
                    }}
                  />
                </GridItem>
              </GridContainer>
              {type === "Single Product" && (
                <GridContainer>
                  <GridItem xs={3} md={3} sm={3}>
                    <Autocomplete
                      id="product"
                      filterOptions={filterOptions}
                      loading={products.length === 0 ? true : false}
                      className={classes.formControl}
                      options={products}
                      value={product}
                      onChange={(event, value) => {
                        setProduct(value);
                        if (value) {
                          setColor(value.color);
                          setProductName(value.productName);
                          setProductCode(value.productCode);
                          if (value.rate) {
                            setRate(value.rate);
                            setSaleRate(value.rate);
                          } else {
                            setRate(0);
                            setSaleRate(0);
                          }
                          setIndex(value.index);
                          setSide(value.side);
                          setTypes(value.type);
                          setSph(value.sph);
                          setCyl(value.cyl);
                          setAxis(value.axis);
                          setAddition(value.addition);
                          setThreshold(value.threshold);
                          setHsnCode(value.hsnCode);
                          setTaxPercent(value.taxPercent);
                          if (value.quantity) {
                            setExistingQuantity(value.quantity);
                            setNewQuantity(0);
                            setTotalQuantity(value.quantity);
                          } else {
                            setExistingQuantity(0);
                            setNewQuantity(0);
                            setTotalQuantity(0);
                          }
                          setTotal(Number(value.quantity) * Number(value.rate));
                        } else {
                          setColor("");
                          setProductName("");
                          setProductCode("");
                          setRate("");
                          setSaleRate("");
                          setIndex("");
                          setSide("");
                          setTypes("");
                          setSph("0");
                          setCyl("0");
                          setAxis("0");
                          setAddition("0");
                          setThreshold("");
                          setExistingQuantity("");
                          setNewQuantity("");
                          setTotalQuantity("");
                        }
                      }}
                      getOptionLabel={(option) =>
                        option.productName
                          ? `${option.productName} (${option.productCode})`
                          : null
                      }
                      onInputChange={(e, value) => {
                        if (value.length > 5) {
                          debouncingProducts(value, { skip: 0, limit: 15 });
                        }
                        return;
                      }}
                      renderInput={(params) => (
                        <TextField {...params} label="Select Product 1" />
                      )}
                    />
                  </GridItem>
                  <GridItem xs={3} md={3} sm={3}>
                    <CustomInput
                      labelText="color"
                      id="color"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: color,
                        onChange: (event) => setColor(event.target.value),
                      }}
                    />
                  </GridItem>
                  <GridItem xs={3} md={3} sm={3}>
                    <CustomInput
                      labelText="Product Name"
                      id="productName"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        className: classes.input,
                        disabled: product ? true : false,
                        value: productName,
                        onChange: (event) => setProductName(event.target.value),
                        placeholder: "Enter product name",
                      }}
                      labelProps={{
                        className: classes.inputLabel
                      }}
                    />
                  </GridItem>
                  <GridItem xs={1} sm={1} md={1}>
                    <CustomInput
                      labelText="Sph"
                      id="sph"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: sph,
                        onChange: (event) => {
                          let sph = event.target.value;
                          setSph(sph);
                        },
                      }}
                    />
                  </GridItem>
                  <GridItem xs={1} sm={1} md={1}>
                    <CustomInput
                      labelText="Cyl"
                      id="cyl"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: cyl,
                        onChange: (event) => setCyl(event.target.value),
                      }}
                    />
                  </GridItem>
                  <GridItem xs={1} sm={1} md={1}>
                    <CustomInput
                      labelText="Axis"
                      id="axis"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: axis,
                        onChange: (event) => setAxis(event.target.value),
                      }}
                    />
                  </GridItem>
                  <GridItem xs={1} sm={1} md={1}>
                    <CustomInput
                      labelText="Addition"
                      id="addition"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: addition,
                        onChange: (event) => setAddition(event.target.value),
                      }}
                    />
                  </GridItem>
                  <GridItem xs={2} md={2} sm={2}>
                    <CustomInput
                      labelText="Index"
                      id="index"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: index,
                        onChange: (event) => setIndex(event.target.value),
                      }}
                    />
                  </GridItem>
                  <GridItem xs={3} md={3} sm={3}>
                    {/* <CustomInput
                      labelText="side"
                      id="side"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: side,
                        onChange: (event) => setSide(event.target.value),
                      }}
                    /> */}
                    <Autocomplete
                      id="side"
                      loading={products.length === 0 ? true : false}
                      className={classes.formControl}
                      options={["B", "R", "L"]}
                      value={side}
                      onChange={(e) => setSide(e.target.value)}
                      getOptionLabel={(option) => option}
                      renderInput={(params) => (
                        <TextField {...params} label="Select Side" />
                      )}
                    />
                  </GridItem>
                  <GridItem xs={2} md={2} sm={2}>
                    <CustomInput
                      labelText="Hsn Code"
                      id="hsnCode"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: hsnCode,
                        onChange: (event) => setHsnCode(event.target.value),
                      }}
                    />
                  </GridItem>
                  <GridItem xs={2} md={2} sm={2}>
                    <CustomInput
                      labelText="Tax percent"
                      id="taxPercent"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: taxPercent,
                        onChange: (event) => setTaxPercent(event.target.value),
                      }}
                    />
                  </GridItem>
                  <GridItem xs={2} md={2} sm={2}>
                    <CustomInput
                      labelText="Threshold"
                      id="threshold"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: threshold,
                        onChange: (event) => setThreshold(event.target.value),
                      }}
                    />
                  </GridItem>
                  <GridItem xs={1} md={1} sm={1}>
                    <CustomInput
                      labelText="type"
                      id="type"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: types,
                        onChange: (event) => setTypes(event.target.value),
                      }}
                    />
                  </GridItem>

                  <GridItem xs={2} sm={2} md={2}>
                    <CustomInput
                      labelText="Sale rate"
                      id="saleRate"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        type: "number",
                        value: saleRate,
                        //   onChange: (event) => setPrice(event.target.value),
                        // onChange: (event) => {
                        //   let n = event.target.value;
                        //   setRate(n);
                        //   let p = Number(newQuantity) * Number(n);
                        //   setTotal(p);
                        // },
                        disabled: true,
                      }}
                    />
                  </GridItem>

                  <GridItem xs={1} sm={1} md={1}>
                    <CustomInput
                      labelText="rate"
                      id="rate"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        type: "number",
                        value: rate,
                        //   onChange: (event) => setPrice(event.target.value),
                        onChange: (event) => {
                          let n = event.target.value;
                          setRate(n);
                          let p = Number(newQuantity) * Number(n);
                          setTotal(p);
                        },
                      }}
                    />
                  </GridItem>
                  <GridItem xs={2} sm={2} md={2}>
                    <CustomInput
                      labelText="Existing Qty"
                      id="existingQuantity"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        disabled: true,
                        type: "number",
                        value: existingQuantity,
                        onChange: (event) =>
                          setExistingQuantity(event.target.value),
                      }}
                    />
                  </GridItem>
                  <GridItem xs={2} sm={2} md={2}>
                    <CustomInput
                      labelText="New Qty"
                      id="newQuantity"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        type: "number",
                        value: newQuantity,
                        onChange: (event) => {
                          let n = event.target.value;
                          setNewQuantity(n);
                          setTotalQuantity(
                            Number(n) + Number(existingQuantity)
                          );
                          let p = Number(n) * Number(rate);
                          setTotal(p);
                        },
                      }}
                    />
                  </GridItem>
                  <GridItem xs={2} sm={2} md={2}>
                    <CustomInput
                      labelText="Total Qty"
                      id="totalQuantity"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        type: "number",
                        value: totalQuantity,
                        disabled: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={1} sm={1} md={1}>
                    <CustomInput
                      labelText="Total"
                      id="total"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        type: "number",
                        disabled: true,
                        value: total,
                        onChange: (event) => setTotal(event.target.value),
                      }}
                    />
                  </GridItem>
                  <GridItem xs={1} sm={1} md={1}>
                    <Box justifyContent={"center"} marginTop={4}>
                      {productCode === "" ? null : (
                        <Fab
                          size={"small"}
                          color="primary"
                          aria-label="add"
                          onClick={() => {
                            let object = {
                              productName,
                              productCode,
                              rate,
                              index,
                              side,
                              type: types,
                              threshold,
                              color,
                              sph,
                              cyl,
                              axis,
                              addition,
                              existingQuantity: existingQuantity,
                              addedQuantity: newQuantity,
                              quantity: totalQuantity,
                              total,
                              _id: product ? product._id : null,
                            };
                            let copy = _.clone(selectedProducts);
                            copy.push(object);
                            setSelectedProducts(copy);
                            let netAmountTemp = Number(netAmount);
                            // _.map(copy, (i) => {
                            netAmountTemp += Number(newQuantity) * Number(rate);
                            // });
                            let totalBillAmount =
                              Number(netAmountTemp) + Number(packagingAmount);
                            setNetAmount(netAmountTemp);
                            if (purchaseType === "Bill") {
                              totalBillAmount =
                                totalBillAmount +
                                (totalBillAmount * Number(taxPercent)) / 100;
                            }
                            setTotalBillAmount(totalBillAmount);

                            setColor("");
                            setProduct(null);
                            setProductName("");
                            setProductCode("");
                            setRate("");
                            setIndex("");
                            setSide("");
                            setTypes("");
                            setSph("0");
                            setCyl("0");
                            setAxis("0");
                            setAddition("0");
                            setThreshold("");
                            setExistingQuantity("");
                            setNewQuantity("");
                            setTotalQuantity("");
                            setTotal("");
                            // setHsnCode("")
                            // setTaxPercent("")
                            // setBill("");
                            // setChallan("");
                          }}
                        >
                          <AddIcon />
                        </Fab>
                      )}
                    </Box>
                  </GridItem>
                  {_.isEmpty(selectedProducts) ? null : (
                    <GridItem xs={12}>
                      <Table stickyHeader aria-label="sticky table">
                        <TableHead className={classes.tableHeader}>
                          <TableRow>
                            {productColumns.map((column) => (
                              <TableCell
                                key={column.id}
                                align={column.align}
                                style={{
                                  minWidth: column.minWidth,
                                  fontWeight: 600
                                }}
                              >
                                {column.label}
                              </TableCell>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {selectedProducts.map((row, index) => {
                            return (
                              <TableRow hover key={index}>
                                {productColumns.map((column) => {
                                  const value = row[column.id];
                                  if (column.id === "action") {
                                    return (
                                      <TableCell align={"center"}>
                                        <Box
                                          display={"flex"}
                                          justifyContent={"center"}
                                        >
                                          <IconButton
                                            aria-label="delete"
                                            onClick={() => {
                                              let copy =
                                                _.clone(selectedProducts);
                                              let deletedProduct = copy[index];

                                              let deletedProductQuantity =
                                                deletedProduct.addedQuantity;
                                              let deletedProductPrice =
                                                deletedProduct.rate;

                                              let deletedProductTotalAmount =
                                                Number(deletedProductQuantity) *
                                                Number(deletedProductPrice);
                                              let netAmountTemp =
                                                Number(netAmount);

                                              console.log(
                                                "netAmountTemp",
                                                netAmountTemp
                                              );
                                              console.log(
                                                "deletedProductTotalAmount",
                                                deletedProductTotalAmount
                                              );

                                              if (
                                                Number(netAmountTemp) -
                                                Number(
                                                  deletedProductTotalAmount
                                                ) <=
                                                0
                                              ) {
                                                netAmountTemp = 0;
                                              } else {
                                                netAmountTemp -=
                                                  deletedProductTotalAmount;
                                              }

                                              let totalBillAmount =
                                                Number(netAmountTemp) +
                                                Number(packagingAmount);

                                              setNetAmount(netAmountTemp);
                                              if (
                                                taxPercent &&
                                                purchaseType === "Bill"
                                              ) {
                                                totalBillAmount =
                                                  netAmountTemp +
                                                  netAmountTemp *
                                                  (Number(taxPercent) / 100);
                                              }
                                              setTotalBillAmount(
                                                totalBillAmount
                                              );

                                              copy.splice(index, 1);
                                              setSelectedProducts(copy);
                                            }}
                                          >
                                            <DeleteIcon />
                                          </IconButton>
                                        </Box>
                                      </TableCell>
                                    );
                                  }
                                  return (
                                    <TableCell
                                      key={column.id}
                                      align={column.align}
                                      className={classes.tableCell}
                                    >
                                      {value}
                                    </TableCell>
                                  );
                                })}
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </GridItem>
                  )}
                </GridContainer>
              )}

              {type === "Range Product" && (
                <GridContainer>
                  <GridItem xs={3} md={3} sm={3}>
                    <Autocomplete
                      id="product"
                      loading={readyMasterRangeLoading}
                      className={classes.formControl}
                      options={memoizedReadyMasterRangeOptions}
                      value={selectedReadyMasterRange}
                      onChange={async (event, value) => {
                        setSelectedReadyMasterRange(value);
                        if (value) {
                          setColor(value.color);
                          setProductName(value.productName);
                          if (value.rate) {
                            setRate(value.rate);
                          } else {
                            setRate(0);
                          }
                          setIndex(value.index);
                          setSide(value.side);
                          setTypes(value.type);
                        } else {
                          setColor("");
                          setProductName("");
                          setProductCode("");
                          setRate("");
                          setIndex("");
                          setSide("");
                          setTypes("");
                          setSph("0");
                          setCyl("0");
                          setAxis("0");
                          setAddition("0");
                          setThreshold("");
                          setExistingQuantity("");
                          setNewQuantity("");
                          setTotalQuantity("");
                        }
                      }}
                      onInputChange={(event, newInputValue) => {
                        setReadyMasterRangeSearchInput(newInputValue);
                        // Trigger debounced search
                        debouncedReadyMasterRangeSearch(newInputValue);
                      }}
                      inputValue={readyMasterRangeSearchInput}
                      filterOptions={(options, state) => {
                        // Client-side filtering from loaded options for better UX
                        const inputValue = state.inputValue.toLowerCase();
                        return options.filter(option =>
                          option.productName &&
                          option.productName.toLowerCase().includes(inputValue)
                        );
                      }}
                      getOptionLabel={(option) =>
                        option.productName ? `${option.productName}` : ""
                      }
                      renderInput={(params) => (
                        <TextField {...params} label="Select Product 2" />
                      )}
                    />
                  </GridItem>
                  <GridItem xs={3} md={3} sm={3}>
                    <CustomInput
                      labelText="color"
                      id="color"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: color,
                        onChange: (event) => setColor(event.target.value),
                      }}
                    />
                  </GridItem>
                  <GridItem xs={3} md={3} sm={3}>
                    <CustomInput
                      labelText="Product Name"
                      id="productName"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        className: classes.input,
                        disabled: product ? true : false,
                        value: productName,
                        onChange: (event) => setProductName(event.target.value),
                        placeholder: "Enter product name",
                      }}
                      labelProps={{
                        className: classes.inputLabel
                      }}
                    />
                  </GridItem>
                  <GridItem xs={2} md={2} sm={2}>
                    <CustomInput
                      labelText="Index"
                      id="index"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: index,
                        onChange: (event) => setIndex(event.target.value),
                      }}
                    />
                  </GridItem>
                  <GridItem xs={3} md={3} sm={3}>
                    {/* <CustomInput
                      labelText="side"
                      id="side"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: side,
                        onChange: (event) => setSide(event.target.value),
                      }}
                    /> */}
                    <Autocomplete
                      id="side"
                      loading={products.length === 0 ? true : false}
                      className={classes.formControl}
                      options={["B", "R", "L"]}
                      value={side}
                      onChange={(e) => setSide(e.target.value)}
                      getOptionLabel={(option) => option}
                      renderInput={(params) => (
                        <TextField {...params} label="Select Side" />
                      )}
                    />
                  </GridItem>
                  <GridItem xs={3} md={3} sm={3}>
                    <CustomInput
                      labelText="type"
                      id="type"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: types,
                        onChange: (event) => setTypes(event.target.value),
                      }}
                    />
                  </GridItem>
                  <GridItem xs={3} sm={3} md={3}>
                    <CustomInput
                      labelText="saleRate"
                      id="saleRate"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        type: "number",
                        value: saleRate,
                        //   onChange: (event) => setPrice(event.target.value),
                        // onChange: (event) => {
                        //   let n = event.target.value;
                        //   setRate(n);
                        //   let p = Number(newQuantity) * Number(n);
                        //   setTotal(p);
                        // },
                        disabled: true,
                      }}
                    />
                  </GridItem>

                  <GridItem xs={3} sm={3} md={3}>
                    <CustomInput
                      labelText="rate"
                      id="rate"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        type: "number",
                        value: rate,
                        //   onChange: (event) => setPrice(event.target.value),
                        onChange: (event) => {
                          let n = event.target.value;
                          setRate(n);
                          let p = Number(newQuantity) * Number(n);
                          setTotal(p);
                        },
                      }}
                    />
                  </GridItem>
                  {loading === true ? (
                    <GridItem
                      xs={12}
                      md={12}
                      style={{
                        display: "flex",
                        textAlign: "center",
                      }}
                    >
                      <h1>Loading...</h1>
                    </GridItem>
                  ) : (
                    <GridItem xs={12}>
                      <CustomInput
                        id="search"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          style: {
                            marginTop: 0,
                            marginRight: 10,
                          },
                          placeholder: "Search by product code, sph, cyl, or axis...",
                          value: searchTerm,
                          onChange: (e) => setSearchTerm(e.target.value),
                          endAdornment: (
                            <InputAdornment position="end">
                              <People />
                            </InputAdornment>
                          ),
                        }}
                      />
                      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                        <Box>
                          <strong>
                            Showing {data.length} products
                            {productListTotal > data.length && (
                              <span style={{ color: "#666", marginLeft: "8px" }}>
                                (Total: {productListTotal} products available{searchTerm ? " matching your search" : ""})
                              </span>
                            )}
                            {!searchTerm && productListTotal > 50 && (
                              <span style={{ color: "#666", marginLeft: "8px", fontStyle: "italic" }}>
                                - Use search to find specific products from the remaining {productListTotal - 50}
                              </span>
                            )}
                          </strong>
                        </Box>
                      </Box>
                      <Table stickyHeader aria-label="sticky table">
                        <TableHead className={classes.tableHeader}>
                          <TableRow>
                            {readyMasterRangeProductColumn.map((column) => (
                              <TableCell
                                key={column.id}
                                align={column.align}
                                style={{ minWidth: column.minWidth }}
                              >
                                {column.label}
                              </TableCell>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {loading ? (
                            <TableRow>
                              <TableCell
                                colSpan={readyMasterRangeProductColumn.length}
                                align="center"
                                style={{ padding: "40px" }}
                              >
                                <h1>Loading...</h1>
                              </TableCell>
                            </TableRow>
                          ) : data.length === 0 ? (
                            <TableRow>
                              <TableCell
                                colSpan={readyMasterRangeProductColumn.length}
                                align="center"
                                style={{ padding: "40px" }}
                              >
                                {searchTerm ? "No products found matching your search." : "No products available."}
                              </TableCell>
                            </TableRow>
                          ) : (
                            data.map((row, index) => {
                              // Check if this product has unsaved changes
                              const productId = row._id || row.productCode || row.code;
                              const hasChanges = productUpdates[productId] &&
                                ((productUpdates[productId].newQuantity || 0) > 0 ||
                                  (productUpdates[productId].threshold || 0) > 0);

                              return (
                                <TableRow
                                  hover
                                  role="checkbox"
                                  tabIndex={-1}
                                  key={row._id || row.code || index}
                                  style={{
                                    backgroundColor: hasChanges ? "#fff3cd" : "inherit", // Light yellow background for modified rows
                                  }}
                                >
                                  {readyMasterRangeProductColumn.map(
                                    (column) => {
                                      const value = row[column.id];
                                      if (column.id === "action") {
                                        return (
                                          <TableCell align={"center"} key={column.id}>
                                            <Box
                                              display={"flex"}
                                              justifyContent={"center"}
                                            >
                                              <IconButton
                                                aria-label="delete"
                                                onClick={() => {
                                                  let copy =
                                                    _.clone(selectedProducts);
                                                  let deletedProduct =
                                                    copy[index];
                                                  let deletedProductQuantity =
                                                    deletedProduct.quantity;
                                                  let deletedProductPrice =
                                                    deletedProduct.rate;
                                                  let deletedProductTotalAmount =
                                                    Number(
                                                      deletedProductQuantity
                                                    ) *
                                                    Number(deletedProductPrice);
                                                  let netAmountTemp =
                                                    Number(netAmount);

                                                  netAmountTemp -=
                                                    deletedProductTotalAmount;

                                                  let totalBillAmount =
                                                    netAmountTemp;
                                                  setNetAmount(totalBillAmount);
                                                  if (
                                                    taxPercent &&
                                                    purchaseType === "Bill"
                                                  ) {
                                                    totalBillAmount =
                                                      netAmountTemp +
                                                      netAmountTemp *
                                                      (Number(taxPercent) /
                                                        100);
                                                  }
                                                  setTotalBillAmount(
                                                    totalBillAmount
                                                  );
                                                  copy.splice(index, 1);
                                                  setSelectedProducts(copy);
                                                }}
                                              >
                                                <DeleteIcon />
                                              </IconButton>
                                            </Box>
                                          </TableCell>
                                        );
                                      }

                                      if (column.id === "newQuantity") {
                                        return (
                                          <TableCell
                                            key={column.id}
                                            align={column.align}
                                          >
                                            <CustomInput
                                              labelText="New Qty"
                                              id="newQuantity"
                                              formControlProps={{
                                                fullWidth: true,
                                              }}
                                              inputProps={{
                                                value: (row["newQuantity"] === null || row["newQuantity"] === undefined || row["newQuantity"] === "")
                                                  ? ""
                                                  : String(row["newQuantity"] || ""),
                                                onChange: (event) => {
                                                  if (event && event.target && event.target !== null) {
                                                    manageDataPunching(
                                                      row,
                                                      event,
                                                      "totalQuantity"
                                                    );
                                                  }
                                                },
                                                type: "number",
                                              }}
                                            />
                                          </TableCell>
                                        );
                                      }

                                      if (column.id === "threshold") {
                                        return (
                                          <TableCell key={column.id} align={column.align}>
                                            <CustomInput
                                              labelText="Threshold"
                                              id="threshold"
                                              formControlProps={{
                                                fullWidth: true,
                                              }}
                                              inputProps={{
                                                value: (row["threshold"] === 0 || row["threshold"] === undefined || row["threshold"] === null || row["threshold"] === "") ? "" : String(row["threshold"] || ""),
                                                onChange: (event) => {
                                                  if (event && event.target && event.target !== null) {
                                                    manageDataPunching(row, event, "threshold");
                                                  }
                                                },
                                                type: "number",
                                              }}
                                            />
                                          </TableCell>
                                        );
                                      }

                                      if (column.id === "index") {
                                        return (
                                          <TableCell
                                            key={column.id}
                                            align={column.align}
                                          >
                                            {index + 1}
                                          </TableCell>
                                        );
                                      }

                                      // Show indicator for productCode if product has changes
                                      if (column.id === "productCode" && hasChanges) {
                                        return (
                                          <TableCell
                                            key={column.id}
                                            align={column.align}
                                          >
                                            <Box display="flex" alignItems="center" gap={1}>
                                              <span>{value}</span>
                                              <Box
                                                style={{
                                                  backgroundColor: "#ff9800",
                                                  color: "white",
                                                  fontSize: "10px",
                                                  padding: "2px 6px",
                                                  borderRadius: "10px",
                                                  fontWeight: "bold",
                                                }}
                                                title="This product has unsaved changes"
                                              >
                                                ✎
                                              </Box>
                                            </Box>
                                          </TableCell>
                                        );
                                      }

                                      return (
                                        <TableCell
                                          key={column.id}
                                          align={column.align}
                                        >
                                          {value}
                                        </TableCell>
                                      );
                                    }
                                  )}
                                </TableRow>
                              );
                            })
                          )}
                        </TableBody>
                      </Table>
                    </GridItem>
                  )}
                </GridContainer>
              )}
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </Dialog>
  );
}

